import React from "react";
import PropTypes from "prop-types";

export default function SidebarNavLink({ icon, label, onClick, className, ariaLabel }) {
    return (
        <button type="button" className={`band-sidebar__nav-link band-sidebar__nav-link--primary${className ? ` ${className}` : ''}`} aria-label={ariaLabel || label} onClick={onClick}>
            <span className="band-sidebar__nav-icon" aria-hidden="true">{icon}</span>
            <span className="band-sidebar__nav-label">{label}</span>
        </button>
    );
}

SidebarNavLink.propTypes = {
    icon: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string,
    ariaLabel: PropTypes.string,
};


